module.exports = __webpack_public_path__ + "img/minedu_2025.f06c64a1.png";